module.exports = __webpack_public_path__ + "img/House Searching.a1ef4ff6.svg";